import React from 'react';
import { styled } from 'styled-components';
import { isEmpty } from 'lodash';

import AuthButton from 'components/Button/AuthButton';
import Column from 'components/common/Column';
import Text from 'components/common/Text';
import { SettlementsNode } from 'containers/SettlementRequest/graphQL/types';
import Row from 'components/common/Row';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 16px 20px 24px;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #dbdcdf;
  background-color: #fff;
`;

interface RequestBottomSheetIProps {
  selectSettlement: SettlementsNode[];
  isAllMinusSettlementsSelected: boolean;
  handleIsOpenRequestModal: () => void;
}

const RequestBottomSheet: React.FC<RequestBottomSheetIProps> = props => {
  const {
    selectSettlement,
    isAllMinusSettlementsSelected,
    handleIsOpenRequestModal,
  } = props;

  const isMinusSettlement = (): number => {
    let price: number = 0;

    selectSettlement.filter(
      item =>
        (price +=
          Number(item.totalPayment.value) + Number(item.totalFee.value)),
    );

    return price;
  };

  const formatTotalPrice = (): string => {
    let price: number = 0;

    selectSettlement.filter(
      item =>
        (price +=
          Number(item.totalPayment.value) + Number(item.totalFee.value)),
    );

    return price.toLocaleString();
  };

  const isAbleRequestSettlement = (): boolean => {
    let price: number = 0;

    selectSettlement.filter(
      item =>
        (price +=
          Number(item.totalPayment.value) + Number(item.totalFee.value)),
    );

    return !isEmpty(selectSettlement) && price >= 0;
  };

  return (
    <Container>
      {isMinusSettlement() < 0 && (
        <Row>
          <Text color="#1b1c1e" size="13px">
            합산 금액이 <span style={{ fontWeight: 700 }}>1원 이상</span>
            이어야만 지급 요청을 할 수 있습니다.
          </Text>
        </Row>
      )}
      {isAbleRequestSettlement() && !isAllMinusSettlementsSelected && (
        <Row>
          <Text color="#1b1c1e" size="13px" style={{ textAlign: 'center' }}>
            정산이 완료되지 않은{' '}
            <span style={{ fontWeight: 700 }}>마이너스 정산서를 포함</span>해야
            <br />
            지급 요청이 가능합니다.
          </Text>
        </Row>
      )}
      <Row justifyContent="space-between" style={{ width: '100%' }}>
        <Column align="flex-start" style={{ width: 'auto' }}>
          <Text color="#989BA2">
            총 {selectSettlement.length}개 지급서 선택됨
          </Text>
          <Text color="#1b1c1e" size="16px" weight={600}>
            총 수입{' '}
            <span
              style={{
                color: isMinusSettlement() >= 0 ? '#1b1c1e' : '#FF4242',
              }}
            >
              {formatTotalPrice()}원
            </span>
          </Text>
        </Column>
        <AuthButton
          name="일괄 지급 요청"
          onClick={handleIsOpenRequestModal}
          isAbled={isAbleRequestSettlement() && isAllMinusSettlementsSelected}
          style={{ padding: '12px 24px', width: 'auto' }}
        />
      </Row>
    </Container>
  );
};

export default RequestBottomSheet;
